export const capitalize = (str: string) => {
  const spacedStr = str.replace(/([a-z])([A-Z])/g, '$1 $2');
  return spacedStr.replace(/\b\w/g, char => char.toUpperCase());
};
